import Image from 'next/image';
import Link from 'next/link';

interface LoginLogoProps {
  className?: string;
}

export const LoginLogo: React.FC<LoginLogoProps> = ({ className }) => {
  return (
    <Link href="/" className="mx-auto lg:absolute lg:top-6 lg:left-2">
      <Image src="/icons/logo.svg" alt="AlterMe" height={32} width={32} />
    </Link>
  );
};
